import { HStack, XText } from "IZOX/_X";

const { ColorX } = require("IZOX/STATIC");

function FooterM(){
  return (
    <HStack bgColor={ColorX.CSS("Stone")} height={32} zIndex={2}>
      <XText color={ColorX.CSS("pureWhite")} fontSize={12}>
        {"© 2023 Mutual Insurance Consultants Co. All rights Reserved."}
      </XText>
    </HStack>
  );
}

export default FooterM;